import { Tooltip } from '@mui/material';
import type React from 'react';
import { _ } from '/@/locale';
export const useHomePhrases = () => {
    return {
        h2h: _('Para acceder al Head to head, seleccioná un lote o creá uno nuevo.'),
        weather: _('Para acceder al Clima, seleccioná un lote o creá uno nuevo.'),
        maps: _('Desplegá las opciones a continuación para acceder a la información de cada Mapa.'),
        recommendation: _('Para obtener una recomendación, seleccioná un lote o creá uno nuevo.'),
        nitrogen: _(
            'Para obtener una recomendación de Nitrógeno, seleccioná un lote o creá uno nuevo. Recordá que el lote debe ser un polígono.'
        ),
        default: _('El primer paso para acceder a las opciones de la app, es seleccionar un lote o crear uno nuevo.'),
        weeds: _('Para obtener una recomendación de protección de Malezas, seleccioná un lote o creá uno nuevo.'),
        FieldDetail: _('Selecciona un lote para acceder al Clima y a todas nuestras recomendaciones.'),
        weatherPhone: _('Para acceder al Clima, seleccioná un lote o creá uno nuevo.'),
    };
};

const HomeTooltip = ({
    children,
    selectedFeature,
}: {
    children: React.ReactNode;
    selectedFeature: keyof ReturnType<typeof useHomePhrases>;
}) => {
    const PHRASES = useHomePhrases();
    return <Tooltip title={PHRASES[selectedFeature] || PHRASES['default']}>{children}</Tooltip>;
};

export default HomeTooltip;
